import { render, staticRenderFns } from "./TextUpdate.vue?vue&type=template&id=26821ba5&scoped=true"
import script from "./TextUpdate.vue?vue&type=script&lang=js"
export * from "./TextUpdate.vue?vue&type=script&lang=js"
import style0 from "./TextUpdate.vue?vue&type=style&index=0&id=26821ba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26821ba5",
  null
  
)

export default component.exports